import { MultaAdministrativaApi } from "@/api/gessan/multaAdministrativa.api";
import {
  MultaAdministrativa,
  MultaAdministrativaFilter,
} from "@/models/gessan/multaAdministrativa";
import { Pagination } from "@/models/sit-pedido/pagination";
import { AxiosObservable } from "axios-observable/dist/axios-observable.interface";

const api = new MultaAdministrativaApi();

const getList = (
  filter: MultaAdministrativaFilter
): AxiosObservable<Pagination<MultaAdministrativa>> => {
  return api.getList(filter);
};

export default {
  getList,
};
